import { FlexTemplateNode, FlexTemplateNodeProps, FlexTemplateRenderer } from 'flex-template-renderer-react';
import * as React from 'react';

import { UitkLayoutConditionalGridColumnRow, UitkLayoutGrid } from 'uitk-react-layout-grid';

interface FlexTemplate extends FlexTemplateNode {
  childNodes: FlexTemplateNode[];
  options: {
    columns: number;
  };
}

export interface LayoutGridProps extends FlexTemplateNodeProps {
  flexTemplateNode: FlexTemplate;
}

export const LayoutGrid: React.FC<LayoutGridProps> = (props: LayoutGridProps) => {
  const { childNodes, options } = props.flexTemplateNode;

  return (
    <UitkLayoutGrid columns={options.columns as UitkLayoutConditionalGridColumnRow}>
      {childNodes && <FlexTemplateRenderer template={childNodes} />}
    </UitkLayoutGrid>
  );
};
